/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
    const grid = document.querySelector('.desk_frames-grid');
    if (!grid) return;

    // Mouse drag to scroll the native overflow-x slider (touch scrolls natively)
    let isDown = false, startX, startScroll;

    grid.addEventListener('mousedown', e => {
      isDown = true;
      startX = e.pageX;
      startScroll = grid.scrollLeft;
      grid.style.cursor = 'grabbing';
    });

    grid.addEventListener('dragstart', e => e.preventDefault());

    document.addEventListener('mousemove', e => {
      if (!isDown) return;
      grid.scrollLeft = startScroll - (e.pageX - startX);
    });

    document.addEventListener('mouseup', () => {
      if (!isDown) return;
      isDown = false;
      grid.style.cursor = '';
    });

    // Video playback
    const section = grid.closest('.desk_frames');
    const videos = section ? Array.from(section.querySelectorAll('.desk_frames-cell-video')) : [];
  
    if (videos.length > 0) {
      let endedCount = 0;
  
      function playAll() {
        endedCount = 0;
        videos.forEach(v => {
          v.currentTime = 0;
          v.play().catch(() => {});
        });
      }
  
      videos.forEach(v => {
        v.addEventListener('ended', () => {
          endedCount++;
          if (endedCount >= videos.length) playAll();
        });
      });
  
      const observer = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
          playAll();
        } else {
          videos.forEach(v => v.pause());
        }
      }, { threshold: 0.2 });
  
      observer.observe(section);
    }
  });
  